export const config = {
    USE_DEFAULT_EXAMPLE: getOrDefault("REACT_APP_USE_DEFAULT_EXAMPLE", "false") === "true",
    DISPLAY_MESSAGE: getOrDefault("REACT_APP_DISPLAY_MESSAGE", "Hello <not set>"),
    cognito: {
        // defaults to local dev values
        USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID || "us-east-1_yETxnP9vX",
        APP_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID || "2fks891r57sqqfsn19if4vb4cu",
    },
};
function getOrDefault(name, defaultVal) {
    const envVar = process.env[name];
    if (!envVar) {
        return defaultVal;
    }
    else {
        return envVar;
    }
}
